import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class ArticleApi {

    static customerArticlebyId(id, categoryId) {
        let url = categoryId ? `${config.articleApi.customerArticle}/${id}/category/${categoryId}` : `${config.articleApi.customerArticle}/${id}`;
        return HTTP.get(url)
            .then(response => response.data)
    }

    static customerArticleStubById(id, categoryId) {
        let url = categoryId ? `${config.articleApi.customerArticle}/${id}/category/${categoryId}/stub` : `${config.articleApi.customerArticle}/${id}/stub`;
        return HTTP.get(url)
            .then(response => response.data)
    }

    static startAnalysis(batchData) {
        // If batchData is just a string (batchLabel), convert to object for backwards compatibility
        const payload = typeof batchData === 'string'
            ? {batchLabel: batchData}
            : batchData;

        return HTTP.post('/private/analysis/start', payload)
            .then(response => response.data);
    }

    static refreshAnalysis(batchId) {
        return HTTP.post(`/private/analysis/${batchId}/refresh`)
            .then(response => response.data);
    }

    static getBatches(page = 0, size = 20) {
        return HTTP.get('/private/analysis/batches', {
            params: {
                page,
                size
            }
        }).then(response => response.data);
    }

    static getBatchDetails(batchId) {
        return HTTP.get(`/private/analysis/batch/${batchId}`)
            .then(response => response.data);
    }

    static startEmbeddings(batchId) {
        return HTTP.post(`/private/analysis/embeddings/start/${batchId}`)
            .then(response => response.data);
    }

    static searchSimilarImages(batchId, description, params = {}) {
        return HTTP.post(`/private/analysis/search`, {
            batchId,
            description: description || '',
            threshold: params.threshold || 0.7,
            limit: params.limit || 10,
            articleId: params.articleId || null
        }).then(response => response.data);
    }

    static shopSearchImages(description, params = {}) {
        return HTTP.post(`/private/analysis/shop-search`, {
            description: description || '',
            threshold: params.threshold || 0.7,
            limit: params.limit || 10,
            articleId: params.articleId || null
        }).then(response => response.data);
    }

    static getBatchStatus(batchId) {
        return HTTP.get(`/private/analysis/batch/${batchId}/status`)
            .then(response => response.data);
    }

    static fetchAllArticles() {
        return HTTP.get(`/private/article/all`)
            .then(response => response.data);
    }

    static lookupArticle(searchTerm) {
        return HTTP.get(`/private/article/search/${searchTerm}`)
            .then(response => response.data);
    }

    static customerArticleBasicStub(id) {
        return HTTP.get(`${config.articleApi.customerArticle}/${id}/basic/stub`)
            .then(response => response.data)
    }

    static customerArticleBasic(id, colorId) {
        return HTTP.get(`${config.articleApi.customerArticle}/${id}/basic/${colorId}`)
            .then(response => response.data)
    }

    static customerArticlePdf(id, variationId, categoryId) {
        let url = '';
        if (categoryId) {
            if (variationId) {
                url = `${config.articleApi.customerArticle}/${id}/variation/${variationId}/category/${categoryId}/pdf`;
            } else {
                url = `${config.articleApi.customerArticle}/${id}/category/${categoryId}/pdf`;

            }
        } else {
            url = `${config.articleApi.customerArticle}/${id}/variation/${variationId}/pdf`;
        }
        return HTTP.get(url, {
            responseType: 'blob', // important
        }).then(response => response.data)
    }

    static basicPdf(id, colorId) {
        return HTTP.get(`${config.articleApi.customerArticle}/${id}/basic/variation/${colorId}/pdf`, {
            responseType: 'blob', // important
        }).then(response => response.data)
    }

    static emailBasicPdf(id, colorId) {
        return HTTP.get(`${config.articleApi.customerArticle}/${id}/basic/variation/${colorId}/email`);
    }

    static requestPrice(id, colorId) {
        return HTTP.get(`${config.articleApi.customerArticle}/${id}/color/${colorId}/price/email`);
    }

    static customerArticleCsv(id, categoryId) {
        let url = categoryId ? `${config.articleApi.customerArticle}/${id}/category/${categoryId}/csv` : `${config.articleApi.customerArticle}/${id}/csv`;
        return HTTP.get(url, {
            responseType: 'blob', // important
        }).then(response => response.data)
    }

    static cardList() {
        return HTTP.get(config.articleApi.cards)
            .then(response => response.data)
    }

    static cardArticleList() {
        return HTTP.get(config.articleApi.cardArticle)
            .then(response => response.data)
    }

    static articleList() {
        return HTTP.get(config.articleApi.customerArticle)
            .then(response => response.data)
    }

    static customerRelatedList(articleId) {
        return HTTP.get(`${config.articleApi.customerArticle}/${articleId}/related`)
            .then(response => response.data)
    }

    static relatedList(articleId) {
        return HTTP.get(`${config.articleApi.article}/${articleId}/related`)
            .then(response => response.data)
    }

    static articlePrice(id, variationId, categoryId) {
        let url = categoryId ? `${config.articleApi.customerArticle}/${id}/variation/${variationId}/category/${categoryId}/pricing` : `${config.articleApi.customerArticle}/${id}/variation/${variationId}/pricing`;
        return HTTP.get(url)
            .then(response => response.data)
    }

    static byId(id) {
        return HTTP.get(`${config.articleApi.article}/${id}`)
            .then(response => response.data)
    }

    static articleStubById(id) {
        return HTTP.get(`${config.articleApi.article}/${id}/stub`)
            .then(response => response.data)
    }

    static generateNegativeStatementPdf(id, catgegoryId, settings) {
        return HTTP.post(`${config.articleApi.customerArticle}/${id}/category/${catgegoryId}/negative-statement`, settings, {
            responseType: 'blob', // important
        })
            .then(response => response.data);
    }

    static generateNegativeStatementListPdf(articleList, catgegoryId, settings) {
        return HTTP.post(`${config.articleApi.customerCategory}/${catgegoryId}/declarations/pdf`, {
            ...settings,
            articleList
        }, {
            responseType: 'blob', // important
        }).then(response => response.data);
    }
}